import { API_URL } from "../utility/constants";


export async function getSurveyQuestion(token) {
    try {
        const response = await fetch(API_URL + "customer/survey/getSurveyQuestion", {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getSurveyQuestionWithId(token, type, id) {
    try {
        const response = await fetch(API_URL + "customer/survey/getSurveyQuestion?" + type + "=" + id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getActiveSurveyQuestionWithId(token, type, id) {
    try {
        const response = await fetch(API_URL + "customer/survey/getActiveSurveyQuestion?" + type + "=" + id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function getSurveyAnswers(token, survey_id) {
    try {
        const response = await fetch(API_URL + "customer/survey/getSurveyAnswers?survey_id=" + survey_id, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};

export async function addSurveyQuestion(token, data) {
    try {
        const response = await fetch(API_URL + `customer/survey/addSurveyQuestion`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function addSurveyAnswer(token, data) {
    try {
        const response = await fetch(API_URL + `customer/survey/addSurveyAnswer`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function updateSurveyQuestion(token, data) {
    try {
        const response = await fetch(API_URL + `customer/survey/updateSurveyQuestion`, {
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred! Please try again later." };
    }
};

export async function deleteSurveyQuestion(token, survey_id) {
    try {
        const response = await fetch(API_URL + "customer/survey/deleteSurveyQuestion?id=" + survey_id, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        });
        return await response.json();
    } catch (error) {
        return { error: true, data: "Some error occurred!" };
    }
};